module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-12.eb6aaf7e.png";